import React, { useCallback, useMemo } from 'react';
import SwipeableViewsStepper from 'app/components/swipeableViews/SwipeableViewsStepper';
import { splitIntoChunks } from 'app/components/swipeableViews/splitArrayIntoChunks';
import isInvalidViewData from 'app/components/swipeableViews/isInvalidViewData';
import TransfersView from 'app/components/transferModule/content/TransfersView';
export default function SwipeableTransferList(_ref) {
  let {
    transfers,
    transfersPerView
  } = _ref;
  const viewData = useMemo(() => {
    return splitIntoChunks(transfers, transfersPerView);
  }, [transfers, transfersPerView]);
  const renderView = useCallback(_ref2 => {
    let {
      index
    } = _ref2;
    if (isInvalidViewData(viewData, index)) {
      return null;
    }
    return /*#__PURE__*/React.createElement(TransfersView, {
      key: "transfer-view-".concat(transfersPerView, "-").concat(index),
      transferList: viewData[index]
    });
  }, [transfersPerView, viewData]);
  return /*#__PURE__*/React.createElement(SwipeableViewsStepper, {
    stepCount: viewData.length,
    hideStepperWithoutPages: true,
    viewRender: renderView,
    "data-sentry-element": "SwipeableViewsStepper",
    "data-sentry-component": "SwipeableTransferList",
    "data-sentry-source-file": "SwipeableTransferList.tsx"
  });
}